import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

export interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const HamburgerButton = ({ isOpen, onClick }: HamburgerButtonProps) => {
  return (
    <div className="flex items-center align-middle justify-center">
      <button onClick={onClick}>
        {isOpen ? (
          <XMarkIcon className="flex items-center justify-center w-10 h-10 p-2 font-semibold text-gray-700 rounded-lg cursor-pointer whitespace-nowrap dark:text-gray-200 hover:text-slate-700 dark:hover:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-800" />
        ) : (
          <Bars3Icon className="flex items-center justify-center w-10 h-10 p-2 font-semibold text-violet-800 rounded-lg cursor-pointer whitespace-nowrap dark:text-gray-200 hover:text-violet-600 dark:hover:text-violet-300 hover:bg-slate-200 dark:hover:bg-slate-800" />
        )}
      </button>
    </div>
  );
};
